<script setup lang="ts">
const props = defineProps<{
  product: ProductCard<Packet | SingleProduct>
}>()

const tag = computed(() => {
  const { subjects, variants } = props.product

  // https://acoundervisning.atlassian.net/browse/EHU-898?focusedCommentId=117425
  if (variants.some((it) => 'series' in it && it.series?.toLowerCase() === 'god i norsk')) {
    return 'FOV og Norsk andrespråk'
  }

  if (subjects.length === 0 || subjects.length >= 8) {
    return 'Alle fag'
  }

  if (subjects.length <= 2) {
    return subjects
      .map((s) => {
        const labels = SUBJECT_LABELS[s]
        return Array.isArray(labels) ? labels[1] : labels
      })
      .join('/')
  }

  // https://acoundervisning.atlassian.net/browse/EHU-898?focusedCommentId=117425
  if (subjects.some((s) => ['SAK', 'SAF', 'SOK', 'SOS', 'POL'].includes(s))) {
    return 'Samfunns- og sosiologifag'
  }

  return 'Tverrfaglig'
})

const totStudents = useTotStudents()

const auth = useAuthorizeStore()

// https://acoundervisning.atlassian.net/browse/EHU-898?focusedCommentId=117425
const formats = computed(() => props.product.formats?.map((format) => {
  if (format === 'laerermateriell') {
    return 'lærerstøtte'
  } else if (['grunnbok', 'arbeidsbok'].includes(format)) {
    return 'lærebok'
  } else if (['digitalbok', 'digitalressurs_laerer', 'digitalressurs_elev'].includes(format)) {
    return 'digitalt'
  } else {
    return format
  }
})?.filter(truthyAndDistinct))

const showDiscount = computed(() =>
  props.product.variants
    .map((v) => calculatePrices(v, totStudents.value, auth.user))
    .some((p) => p !== 'NOT_APPLICABLE' && !!p.discounted),
)
</script>

<template>
  <CardsRelated :product="product" :tag="tag">
    <template #subtitle>
      <ul v-if="formats" class="flex flex-wrap gap-1">
        <li
          v-for="format in formats"
          :key="format"
          class="text-[0.8125rem] tracking-[1%] capitalize not-last:after:pl-1 not-last:after:content-['|']"
        >
          {{ format }}
        </li>
      </ul>
    </template>

    <template #icon>
      <IconsDiscount
        v-if="showDiscount"
        size="small"
        aria-label="Produktet er på tilbud"
        class="[--background:white] [--color:var(--color-coral-pop)] [--stroke:none]"
      />
    </template>
  </CardsRelated>
</template>
